import { IApplicationState } from '../../types/redux';

export function getHouses(state: IApplicationState) {
  return state.newbuilding.houses.filter(house => !!house.fromDeveloperPropsCount);
}
